package oldframes.segments

import bootstrap.Button
import oldcomponents.NotyType
import oldcomponents.dropdownSelect
import oldcomponents.page.*
import oldcomponents.showNotification
import ru.it_mozaika.sender.js.application.context.UserContext
import web.cssom.ClassName
import io.ktor.client.call.*
import io.ktor.http.*
import js.core.jso
import kotlinx.html.InputType
import kotlinx.html.js.onChangeFunction
import org.w3c.dom.HTMLInputElement
import react.dom.div
import react.dom.input
import react.dom.label
import react.fc
import react.router.dom.Link
import react.router.useNavigate
import react.useContext
import react.useState
import ru.it_mozaika.sender.common.models.SenderUpdateRequest
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.common.models.UserRole
import ru.it_mozaika.sender.js.application.Http

val newSegmentFrame = fc<PageContentProps> { props ->

    val navigate = useNavigate()

    var stores by useState(listOf<Store>())

    var name by useState("")
    var store by useState("")
    var email by useState("")
    var reply by useState("")
    val currentUser = useContext(UserContext).currentUser

    child(pageContent) {
        attrs.headerProps = jso{
            header = "Создание"
            breadcrumbs = listOf(
                Breadcrumb("/", "", "ti ti-home"),
                Breadcrumb("/senders", "Отправители", ""),
                Breadcrumb("/senders/new", "Создание", ""),
            )
        }
        attrs.active = props.active
        child(widget) {

            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Название:" }
                div("col-lg-9") {
                    input(InputType.text, classes = "form-control") {
                        attrs.value = name
                        attrs.onChangeFunction = {
                            name = (it.target as? HTMLInputElement)?.value.orEmpty()
                        }
                    }
                }
            }
            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Магазин:" }
                div("col-lg-9") {
                    child(dropdownSelect) {
                        attrs {
                            dropdownOpenDefault = false
                            multiSelect = false
                            showFilter = false
                            currentValue = mapOf(store to stores.firstOrNull { it.id == store }?.name.orEmpty())
                            selectValues = stores.map { it.id to it.name }
                            onSave = {
                                store = it.keys.firstOrNull() ?: stores.firstOrNull()?.id ?: ""
                            }
                        }
                    }
                }
            }

            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Email:" }
                div("col-lg-9") {
                    input(InputType.url, classes = "form-control") {
                        attrs.value = email
                        attrs.onChangeFunction = {
                            email = (it.target as? HTMLInputElement)?.value.orEmpty()
                        }
                    }
                }
            }
            div("form-group row d-flex align-items-center mb-5") {
                label("col-lg-3 form-control-label") { +"Email для ответа:" }
                div("col-lg-9") {
                    input(InputType.url, classes = "form-control") {
                        attrs.value = reply
                        attrs.onChangeFunction = {
                            reply = (it.target as? HTMLInputElement)?.value.orEmpty()
                        }
                    }
                }
            }

            div("row d-flex justify-content-end mr-2 ml-2") {
                Link {
                    attrs.to = "/senders"
                    Button {
                        attrs.type = web.html.ButtonType.button
                        attrs.variant = "shadow"
                        attrs.className = ClassName("mr-2")
                        +"Назад"
                    }
                }
                Button {
                    attrs.type = web.html.ButtonType.button
                    attrs.variant = "primary"
                    attrs.active = currentUser!!.role == UserRole.Admin
                    attrs.onClick = {
                        Http.put("/senders", SenderUpdateRequest(name, store, email, reply)) { response ->
                            when (response.status) {
                                HttpStatusCode.NoContent -> {
                                    showNotification("Новый элемент создан", NotyType.Success)
                                    navigate("/senders/${response.headers["ID"].orEmpty()}")
                                }
                                HttpStatusCode.Forbidden -> { showNotification("Недостаточно прав доступа", NotyType.Error) }
                                HttpStatusCode.BadRequest -> { showNotification("Ошибка в запросе: ${response.body<String>()}", NotyType.Error) }
                            }

                        }
                    }
                    +"Создать"
                }
            }

        }
    }
}